import process from "process";
import { HttpTransportType, HubConnectionBuilder, HubConnectionState, LogLevel } from "redux-signalr";

const hubUrl = `${process.env.BACKEND_ROOT}/hub`;

const connection = new HubConnectionBuilder()
	.configureLogging(LogLevel.Debug)
	.withUrl(hubUrl, {
		skipNegotiation: true,
		transport: HttpTransportType.WebSockets,
		accessTokenFactory: (() => {
			const jwtItem = localStorage.getItem("user_jwt");

			return jwtItem ?? "";
		}),
		
	})
	.withAutomaticReconnect()
	.build();

connection.onclose((error) => {
	console.error("SignalR connection closed. Error:", error);
});
	
connection.onreconnecting((error) => {
	console.warn("SignalR reconnecting. Error:", error);
});
	
connection.onreconnected((connectionId) => {
	console.log("SignalR reconnected. Connection ID:", connectionId);
});

connection.on("WentToQuote", (quoteId) => {
	console.log("Went to quote: ", quoteId);
});

const EnsureConnectionMade = async () => {
	if (connection.state === HubConnectionState.Disconnected || connection.state === HubConnectionState.Reconnecting) {
		try {
			await connection.start();
			console.log("ignnalR connected");
		} catch (e) {
			console.error("SignalR connection failed:", e);
		}
	} else {
		console.log("SignalR ALREADY connected");
	}
};

// // store: any, callback: (() => void)
// export function signalRStart() {
// 	const _hub = connection;

// 	// _hub.invoke .firstClientFunction = (p1: any) => {
// 	// 	store.dispatch({ type: "SERVER_CALLED_ME", a: p1 });
// 	// }

// 	// _hub.start(() => callback());
// }

export {
	EnsureConnectionMade
};

export default connection;
